export default __webpack_public_path__ + "static/sarawak-79f0d5016f4517ac0457cf3146fc601d.png";